import { DefineOwnModule } from 'stores/type';
import { sortAlphabetically, sortChronologicallyFromList } from 'helpers/sort';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  library: [],
  rendered: false,
  sortBy: 'alphabet',
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    library: (state) => state.library,
    hasLibrary: (state) => !!state.library.length,
    hasInLibrary: (state) => (id) => state.library.includes(`${ id }`),
    librarySortBy: (state) => state.sortBy,

    isLibraryRendered: (state) => state.rendered,
  },

  actions: {
    libraryReload({ commit, getters }) {
      let library = [
        ...getters.prime,
        ...getters.progress,
        ...getters.base,
      ];

      if (!getters.isArtModeEnabled) {
        library = library.filter((id) => {
          const isBeingMixed = getters.mixStatus
            && (getters.mixFather!.elementId === id || getters.mixMother!.elementId === id);

          if (isBeingMixed) return true;
          if (getters.elementIsExhausted(id) && !getters.isExhaustedVisible(id)) return false;

          return true;
        });
      } else {
        library = library.concat(getters.final);
      }

      let sorted;
      if (getters.librarySortBy === 'timestamp') {
        sorted = sortChronologicallyFromList(getters.total, library);
      } else {
        sorted = sortAlphabetically(getters.elements, library);
      }
      commit('LIBRARY_RELOAD', sorted);
    },
    libraryRendered({ commit }) {
      commit('LIBRARY_RENDERED');
    },

    libraryChangeSorting({ dispatch, commit }, sortBy) {
      commit('LIBRARY_SORTING', sortBy);
      dispatch('libraryReload');
    },
  },

  mutations: {
    LIBRARY_RELOAD(state, sorted) {
      state.library = sorted;
    },
    LIBRARY_RENDERED(state) {
      state.rendered = true;
    },

    LIBRARY_SORTING(state, sortBy) {
      if (state.sortBy === sortBy) return;

      state.sortBy = sortBy;
    },
  },
};

export default storeModule;
